<script>
import baseList from '@/views/components/base/baseList.vue'
import { Tag, Button } from 'view-design'
import Vue from 'vue'
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: 'knowledgeComment',
        key: 'id',
        url: {
          del: '/admin/system/message',
        },
        output: false,
      },
      filters: [
        { label: '时间选择',KeyEnter : this.search, name: 'start_time', value: '', type: 'datetimerange' },
        { label: '留言内容',KeyEnter : this.search, name: 'message', value: '', type: 'input' },
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: '留言知识库名称',
          key: 'article',
          minWidth: 120,
          align: 'center',
        },
        {
          title: '内容',
          key: 'message',
          minWidth: 120,
          align: 'left',
        },
        {
          title: '留言人',
          minWidth: 180,
          align: 'center',
          key: 'fname',
        },
        {
          title: '留言时间',
          minWidth: 180,
          align: 'center',
          key: 'createTime',
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          key: 'handle',
          fixed: 'right',
          handle: [
            // (vm, h, currentRow, param) => {
            //   let directives = [{ name: "auth", value: "/admin/knowledgeBaseClass/edit" }];
            //   return (
            //     <Button {...{ directives }} size="small" onClick={() => this.handleEdit(currentRow)} type="primary" style={{ margin: "4px 5px" }}>
            //       编辑
            //     </Button>
            //   );
            // },
            'delete',
          ],
          // auth: {
          //   del: "/admin/comment/del",
          // },
        },
      ],
    }
  },
  created() {
    let query = this.$route.query
    if (query.knowledgeId) {
      this.query.knowledgeId = query.knowledgeId
    }
  },
  methods: {
    // 分类
    // loadLevelData() {
    //   let q = {}
    //   $utils.api.load('serviceCategoryDropTree', q).then((res) => {
    //     if (res && res.data) {
    //       let ll = res.data
    //       let dropList = []
    //       for (let index = 0; index < ll.length; index++) {
    //         const element = ll[index]
    //         let xx = {}
    //         xx.value = element.category_id
    //         xx.name = element.name
    //         xx.children = element.children || []
    //         dropList.push(xx)
    //       }
    //       for (let index = 0; index < this.filters.length; index++) {
    //         const element = this.filters[index]
    //         if (element && element.name == 'category_id') {
    //           // this.items[index]['dropList'] = dropList
    //           this.filters[index]['dropList'] = (this.filters[index]['dropList'] || []).concat(dropList)
    //         }
    //       }
    //     }
    //   })
    // },
    // toAdd() {
    //   $utils.url.push({ name: 'knowledgeBaseClass_add', query: { action: 'add' } })
    // },
    // handleEdit(currentRow){
    //   $utils.url.push({ name: "knowledgeBaseClass_edit", query: {action: "edit", kv: currentRow.id } });
    // },
  },
}
</script>
<style scoped></style>
